export enum SidebarModesEnum {
  AddressBook = 'address_book',
  FixedAddress = 'fixed_address',
  None = '',
}
